export enum ReturnProductStrategy {
  StoreCredit = "store_credit",
  Refund = "refund",
  None = "none",
  Repair = "repair",
}
